function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 8,
  cy: 7.68,
  rx: 8,
  ry: 7.68,
  fill: "#112C79",
  fillOpacity: 0.8
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.9 3.6C8.324 3.6 8.684 3.688 8.98 3.864C9.276 4.032 9.5 4.256 9.652 4.536C9.804 4.816 9.88 5.12 9.88 5.448C9.88 5.744 9.836 5.996 9.748 6.204C9.66 6.412 9.556 6.588 9.436 6.732C9.316 6.868 9.152 7.024 8.944 7.2C8.656 7.448 8.44 7.676 8.296 7.884C8.16 8.084 8.092 8.356 8.092 8.7V9.252H7.084V8.64C7.084 8.312 7.128 8.032 7.216 7.8C7.304 7.568 7.412 7.384 7.54 7.248C7.668 7.104 7.836 6.94 8.044 6.756C8.308 6.532 8.5 6.332 8.62 6.156C8.748 5.98 8.812 5.744 8.812 5.448C8.812 5.136 8.724 4.896 8.548 4.728C8.38 4.552 8.144 4.464 7.84 4.464C7.584 4.464 7.348 4.528 7.132 4.656C6.924 4.784 6.708 4.992 6.484 5.28L5.836 4.776C6.372 3.992 7.06 3.6 7.9 3.6ZM7.612 10.56C7.844 10.56 8.032 10.64 8.176 10.8C8.32 10.952 8.392 11.136 8.392 11.352C8.392 11.568 8.32 11.756 8.176 11.916C8.032 12.068 7.844 12.144 7.612 12.144C7.388 12.144 7.204 12.068 7.06 11.916C6.916 11.756 6.844 11.568 6.844 11.352C6.844 11.136 6.916 10.952 7.06 10.8C7.204 10.64 7.388 10.56 7.612 10.56Z",
  fill: "#F2F2F2"
});

var SvgQuestionIcon = function SvgQuestionIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuestionIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/question-icon.ac4e5e9e.svg";
export { ForwardRef as ReactComponent };